// src/app.ts —— 后台组合入口（TD-804 / TD-806）：createDcApp + 服务绑定（原型字典经 initialState 并入 createDcApp 字典链，TD-805）
import { createDcApp, type Dict, type GpApp } from '../../shared/src/dc';
import type { IdleEnv } from '../../shared/src/idle';
import { readLocal } from '../../shared/src/storage';
import { DOMAINS } from './domains/index';
import { shellDefaults } from './domains/shell';
import { createServices, type AdminGp } from './gp';
import { dashDefaults, settingsDefaults, tableDefaults, type AdminState } from './state';

// apiBase：产品同源（''）；node 用例注入 msw 绝对地址。idleEnv：缺省取浏览器空闲环境，用例注入假环境
export function createAdminApp(opts: { dev: boolean; apiBase?: string; idleEnv?: IdleEnv | null }): GpApp<AdminState> & { gp: AdminGp } {
  let dictOf: () => Dict = () => ({});
  const holder: { gp: AdminGp | null } = { gp: null };
  // TD-822：screen 初值恒为 booting（不读 props.startLoggedIn）；boot 结束由 session.established 切 app，否则切 login
  const base: AdminState = {
    lang: 'zh',
    screen: 'booting',
    page: 'dashboard',
    tab: 0,
    sidebar: readLocal('gpa_sidebar') !== '0', // C-24「折叠状态存 localStorage」
    adminUser: '',
    toast: '',
    toastId: 0,
    sh: shellDefaults(),
    tb: tableDefaults(),
    st: settingsDefaults(),
    ds: dashDefaults(),
  };
  const app = createDcApp<AdminState, AdminGp>({
    base,
    domains: DOMAINS,
    services: (events) => {
      const g = createServices(events, { dict: () => dictOf(), base: opts.apiBase ?? '', ...(opts.idleEnv !== undefined ? { idleEnv: opts.idleEnv } : {}) });
      holder.gp = g;
      return g;
    },
    dev: opts.dev,
  });
  const wrapped: GpApp<AdminState> = {
    ...app,
    didMount(host) {
      holder.gp?.bind(host);
      dictOf = () => app.t(host);
      app.didMount(host);
    },
  };
  if (!holder.gp) throw new Error('services 未初始化');
  return { ...wrapped, gp: holder.gp };
}
